import { ErrorCode } from "@/enums/ErrorCode";
import { AxiosError } from "axios";
import z from "zod";

const httpStatusExceptionSchema = z.object({
    message: z.string().nullish(),
    errors: z.record(z.string()).nullish(),
    errorCode: z.string().nullish(),
    isEmpty: z.boolean().nullish(),
    status: z.number().nullish(),
});

export type HttpStatusExceptionSchema = z.infer<typeof httpStatusExceptionSchema>;

export type SpecificHttpStatusExceptionSchema = HttpStatusExceptionSchema & {
    errorCode: ErrorCode;
}

const empty: HttpStatusExceptionSchema = {
    message: null,
    errors: null,
    errorCode: null,
    isEmpty: true,
    status: null,
};

export default {
    schema: httpStatusExceptionSchema,
    empty,
    mergeErrorMessages: (e: HttpStatusExceptionSchema, fallbackMessage: string) => {
        if (e.errors && Object.keys(e.errors).length) {
            const messages = Object.values(e.errors).flat();
            if (messages.length > 0) {
                return messages.join(", ");
            }
        }
        return fallbackMessage;
    },
    mapFromError: (error: unknown): HttpStatusExceptionSchema => {
        if (!(error instanceof AxiosError)) return empty;
        const parsed = httpStatusExceptionSchema.safeParse(error.response?.data);
        if (!parsed.success) return empty;
        return {
            ...parsed.data,
            status: error.response?.status ?? null,
        }
    }
}